import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createBlock as _createBlock, KeepAlive as _KeepAlive } from "vue"

import { PropType, defineAsyncComponent, computed, ref } from 'vue'

type modeType = 'primary' | 'secondary' | 'dark' | 'tertiary' | 'danger' | 'ghost'
type sizeType = 'x-small' | 'small' | 'medium'


export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'v-button'
},
  __name: 'VButton',
  props: {
	mode: {
		type: String as PropType<modeType>,
		default: 'primary'
	},
	size: {
		type: String as PropType<sizeType>,
		default: 'x-small'
	},
	text: {
		type: String,
		default: undefined
	},
	disabled: {
		type: Boolean,
		default: false
	},
	focusBg: {
		type: Boolean,
		default: false
	},
	loading: {
		type: Boolean,
		default: false
	},
	loadingAbsolute: {
		type: Boolean,
		default: false
	},
},
  setup(__props) {



const sizes = ref({
	'x-small': 'px-3 min-h-8 rounded-lg !text-xs',
	'xs/s': 'px-[13px] min-h-9 rounded-[9px] !text-sm',
	small: 'px-[14px] min-h-10 rounded-[10px] !text-base',
	medium: 'px-4 min-h-12 rounded-xl !text-lg',
});

const props = __props;

const loadingRightOffset = computed(() => ({
	'x-small': 'right-3',
	'xs/s': 'right-[13px]',
	small: 'right-[14px]',
	medium: 'right-4',
})[props.size])

const capitalizedMode = computed(() => props.mode?.toCapitalize?.())

const asyncComponent = defineAsyncComponent(async () => {
	const { default: component } = await import(`./${capitalizedMode.value}Button.vue`);
	return component;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_KeepAlive, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(asyncComponent)), _mergeProps(_ctx.$props, {
      class: ["flex justify-center items-center gap-2 transition-all duration-150 focus-visible:!outline-2 focus-visible:!outline-transparent focus-visible:!ring-4 focus-visible:!ring-blue-500 focus:outline-blue-500", sizes.value[__props.size] + (__props.loadingAbsolute ? ' relative' : '')]
    }), _createSlots({
      "right-icon": _withCtx(() => [
        (__props.loading)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: _normalizeClass(["fa-solid fa-spinner text-[1.3em]", {
						[`absolute ${loadingRightOffset.value}`]: __props.loadingAbsolute
					}])
            }, null, 2))
          : _renderSlot(_ctx.$slots, "right-icon", { key: 1 })
      ]),
      _: 2
    }, [
      _renderList(_ctx.$slots, (_, name) => {
        return {
          name: name,
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, name)
          ])
        }
      })
    ]), 1040, ["class"]))
  ], 1024))
}
}

})